<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Mesa (Id {{mesaId}})</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Mesa',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    mesaId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
          route: {name: 'mesa_info', params: {mesaId: this.mesaId}},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
